import { render, staticRenderFns } from "./assignTags.vue?vue&type=template&id=4a8c305c&scoped=true"
import script from "./assignTags.vue?vue&type=script&lang=js"
export * from "./assignTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c305c",
  null
  
)

export default component.exports